'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _DrawingTool = require('./DrawingTool');var _DrawingTool2 = _interopRequireDefault(_DrawingTool);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

DrawingOverlay = function (_Component) {_inherits(DrawingOverlay, _Component);function DrawingOverlay() {var _temp, _this, _ret;_classCallCheck(this, DrawingOverlay);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.





















    eventCanvas = function (event) {
      var mobileOverlayOffset = _constants.mobileFiltersHeight + _constants.mobileHeaderHeight;

      if (_this.props.isMobile) {
        event._x = (0, _get2.default)(event, 'touches[0].clientX');
        event._y = (0, _get2.default)(event, 'touches[0].clientY') - mobileOverlayOffset;
      } else if (event.layerX || event.layerX === 0) {
        event._x = event.layerX;
        event._y = event.layerY;
      } else if (event.offsetX || event.offsetX === 0) {
        event._x = event.offsetX;
        event._y = event.offsetY;
      }

      if (event.type === 'touchend') {
        event._x = (0, _get2.default)(event, 'changedTouches[0].clientX');
        event._y = (0, _get2.default)(event, 'changedTouches[0].clientY') - mobileOverlayOffset;
      }

      _this.drawingTool[event.type](event);
      if (event.type === 'mouseup' || event.type === 'touchend') {
        _this.props.applyDrawnPolygon(_DrawingTool2.default.coordinates);
        var context = _this.context.clearRect ? _this.context : event.target.getContext('2d');
        if (context) {
          context.clearRect(0, 0, _this.canvas.width, _this.canvas.height);
        }
        _DrawingTool2.default.coordinates = [];
      }
    }, _this.

    cancelDraw = function () {
      _this.context.clearRect(0, 0, _this.canvas.width, _this.canvas.height);
      _DrawingTool2.default.coordinates = [];
      _this.props.cancelDraw();
    }, _temp), _possibleConstructorReturn(_this, _ret);}DrawingOverlay.prototype.componentDidMount = function componentDidMount() {this.canvas = document.getElementById('drawingCanvas');this.context = this.canvas.getContext('2d');this.context.lineWidth = this.props.lineWidth;this.context.strokeStyle = this.props.lineColor;this.drawingTool = new _DrawingTool2.default(this.context);var isMobile = this.props.isMobile;this.canvas.addEventListener(isMobile ? 'touchstart' : 'mousedown', this.eventCanvas, false);this.canvas.addEventListener(isMobile ? 'touchmove' : 'mousemove', this.eventCanvas, false);this.canvas.addEventListener(isMobile ? 'touchend' : 'mouseup', this.eventCanvas, false);};DrawingOverlay.prototype.componentWillUnmount = function componentWillUnmount() {var isMobile = this.props.isMobile;this.canvas.removeEventListener(isMobile ? 'touchstart' : 'mousedown', this.eventCanvas, false);this.canvas.removeEventListener(isMobile ? 'touchmove' : 'mousemove', this.eventCanvas, false);this.canvas.removeEventListener(isMobile ? 'touchend' : 'mouseup', this.eventCanvas, false);};DrawingOverlay.prototype.

  render = function render() {
    return (
      _react2.default.createElement('canvas', { id: 'drawingCanvas', width: this.props.width, height: this.props.height }));

  };return DrawingOverlay;}(_react.Component);


DrawingOverlay.propTypes = {
  isMobile: _propTypes2.default.bool,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  lineWidth: _propTypes2.default.number,
  lineColor: _propTypes2.default.string,
  cancelDraw: _propTypes2.default.func,
  applyDrawnPolygon: _propTypes2.default.func };exports.default =


DrawingOverlay;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DrawingOverlay/DrawingOverlay.js
// module id = 2656
// module chunks = 0